import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { activeUserCharOptions, matchesUserCharOption } from '@/lib/user-char-lookups';
import type { BookingType, UserCharLookupOption } from '@/types';

interface Props {
  bookingType: Pick<BookingType, 'userCharOptions'> | null | undefined;
  index: number;
  value: string;
  optionId?: number;
  label: string;
  required?: boolean;
  disabled?: boolean;
  allowCurrentValue?: boolean;
  onChange: (value: string, option?: UserCharLookupOption) => void;
}

export function UserCharLookupSelect({ bookingType, index, value, optionId, label, required, disabled, allowCurrentValue, onChange }: Props) {
  const options = activeUserCharOptions(bookingType, index);
  const selectedOption = options.find(o => matchesUserCharOption(o, value, optionId));
  const currentOnly = !!value && !selectedOption;
  return (
    <div className="space-y-1">
      <Select value={currentOnly ? '__current__' : selectedOption ? String(selectedOption.id || `value:${selectedOption.value}`) : required ? '' : '__empty__'} disabled={disabled || (!options.length && !currentOnly)}
        onValueChange={selected => {
          if (selected === '__current__') return;
          if (selected === '__empty__') onChange('');
          else {
            const option = options.find(o => String(o.id || `value:${o.value}`) === selected);
            if (option) onChange(option.value, option);
          }
        }}>
        <SelectTrigger className="h-8 text-xs" aria-label={label} aria-required={required}>
          <SelectValue placeholder={`Select ${label.toLowerCase()}`} />
        </SelectTrigger>
        <SelectContent>
          {!required && <SelectItem value="__empty__">None</SelectItem>}
          {currentOnly && allowCurrentValue && <SelectItem value="__current__">{value} (current value only)</SelectItem>}
          {options.map(option => <SelectItem key={option.id || option.value} value={String(option.id || `value:${option.value}`)}>{option.value}</SelectItem>)}
        </SelectContent>
      </Select>
      {!options.length && <p className="text-xs text-destructive">Administrator lookup configuration required.</p>}
    </div>
  );
}
